var a = Object.defineProperty, f = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var m = (o, e, r) => e in o ? a(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, i = (o, e) => {
  for (var r in e || (e = {}))
    c.call(e, r) && m(o, r, e[r]);
  if (t)
    for (var r of t(e))
      s.call(e, r) && m(o, r, e[r]);
  return o;
}, n = (o, e) => f(o, p(e));
import g, { forwardRef as I } from "react";
import d from "../lib/IconBase.mjs";
import l from "../defs/SignIn.mjs";
const w = I((o, e) => /* @__PURE__ */ g.createElement(d, n(i({ ref: e }, o), { weights: l })));
w.displayName = "SignIn";
export {
  w as SignIn
};
